import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid2,
  TextField,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Loading } from "./Loading";
import { useEffect, useState } from "react";
import { PayoutDTO } from "../model/entity/PayoutDTO";
import dayjs from "dayjs";
import {
  PayoutDTOValidationObj,
  payoutDTOValidationObjInit,
  validatePayoutDTO,
} from "../model/validation/PayoutDTOValidation";
import { putFetcher } from "./Fetchers";
import { notifErr, notifOk } from "./Functions";
import handleAxiosError from "./ErrorHandler";

interface PayoutDTODialogProps {
  open: boolean;
  selectedPayoutDTO: PayoutDTO;
  handleCancel: any;
}

const PayoutDTODialog = (props: PayoutDTODialogProps) => {
  const [payoutDTO, setPayoutDTO] = useState<PayoutDTO | null>(
    props.selectedPayoutDTO
  );
  const [payoutDTOErr, setPayoutDTOErr] = useState<PayoutDTOValidationObj>(
    payoutDTOValidationObjInit
  );
  const [triedSubmit, setTriedSubmit] = useState(false);

  useEffect(() => {
    if (!payoutDTO) return;
    if (triedSubmit) setPayoutDTOErr(validatePayoutDTO(payoutDTO));
  }, [payoutDTO, triedSubmit]);

  const handleInputChange = (e: any) => {
    if (!payoutDTO) return;
    setPayoutDTO({ ...payoutDTO, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!payoutDTO) return;
    setTriedSubmit(true);

    const payoutDTOErrors = validatePayoutDTO(payoutDTO);
    setPayoutDTOErr(payoutDTOErrors);

    if (Object.values(payoutDTOErrors).some((val) => val === false)) return;

    try {
      await putFetcher(
        `${process.env.REACT_APP_API_URL}/payouts/${payoutDTO.id}`,
        payoutDTO
      );
      notifOk("Změny byly uloženy.");
      props.handleCancel();
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (!payoutDTO) return <Loading />;

  return (
    <Dialog open={props.open} onClose={() => props.handleCancel()}>
      <DialogContent dividers>
        <Grid2 container spacing={2} size={{ xs: 12 }}>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="h5">
              {payoutDTO.coach.firstName +
                " " +
                payoutDTO.coach.lastName +
                " - " +
                dayjs(
                  `${payoutDTO.year}-${String(payoutDTO.month).padStart(
                    2,
                    "0"
                  )}`
                )
                  .locale("cs")
                  .format("MMMM YYYY")
                  .replace(/^./, (c) => c.toUpperCase())}
            </Typography>
            <FormControlLabel
              control={<Checkbox />}
              label="Vyplaceno"
              checked={payoutDTO.paid}
              onChange={() =>
                setPayoutDTO({
                  ...payoutDTO,
                  paid: !payoutDTO.paid,
                })
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <Typography>
              <b>Čas vyplacení: </b>
              {payoutDTO.paidTimeStamp
                ? dayjs(payoutDTO.paidTimeStamp).format("DD.MM.YYYY HH:mm:ss")
                : "N/A"}
            </Typography>
            <Typography>
              <b>Číslo bankovního účtu:</b> {payoutDTO.coach.accountNumber}
            </Typography>
            <Typography>
              <b>Stálá hodinová sazba:</b> {payoutDTO.coach.wage}Kč
            </Typography>
            <Typography>
              <b>Stálá sazba daně:</b> {payoutDTO.coach.tax}%
            </Typography>
          </Grid2>

          <Grid2 size={{ xs: 12 }}>
            <InputLabel sx={{ color: "black" }}>
              Individuální hod. sazba pro tento měsíc (Kč)
            </InputLabel>
            <TextField
              size="small"
              sx={{ width: "25%" }}
              type="number"
              required
              name="coachWage"
              value={payoutDTO.coachWage}
              error={!payoutDTOErr.coachWage}
              onChange={handleInputChange}
            />
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            <InputLabel sx={{ color: "black" }}>
              Individuální sazba daně pro tento měsíc (%)
            </InputLabel>
            <TextField
              sx={{ width: "25%" }}
              size="small"
              type="number"
              required
              name="coachTax"
              value={payoutDTO.coachTax}
              error={!payoutDTOErr.coachTax}
              onChange={handleInputChange}
            />
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "right", gap: 1 }}>
        <Button
          variant="outlined"
          className="cancelBtn"
          onClick={props.handleCancel}
        >
          Zrušit
        </Button>
        <Button variant="outlined" className="submitBtn" onClick={handleSubmit}>
          Uložit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PayoutDTODialog;
